// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Decimal } from 'decimal.js';
import { Holding as TokenStandardHolding } from '@daml.js/splice-api-token-holding/lib/Splice/Api/Token/HoldingV1';
import InterfaceContract from './InterfaceContract';

export const getHoldingsToCoverAmount: (
  holdings: InterfaceContract<TokenStandardHolding>[],
  requiredAmount: Decimal,
) => InterfaceContract<TokenStandardHolding>[] = (holdings, requiredAmount) => {
  const sortedHoldings = [...holdings].sort((a, b) =>
    new Decimal(a.view(TokenStandardHolding).amount).comparedTo(
      new Decimal(b.view(TokenStandardHolding).amount),
    ),
  );

  const { result, accumulated } = sortedHoldings.reduce(
    (acc, holding) => {
      if (acc.accumulated.greaterThanOrEqualTo(requiredAmount)) {
        return acc; // already satisfied
      }

      const amount = new Decimal(holding.view(TokenStandardHolding).amount);
      return {
        result: [...acc.result, holding],
        accumulated: acc.accumulated.plus(amount),
      };
    },
    {
      result: [] as InterfaceContract<TokenStandardHolding>[],
      accumulated: new Decimal(0),
    },
  );

  return accumulated.greaterThanOrEqualTo(requiredAmount) ? result : [];
};
